import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const add_event = createAsyncThunk(
  "event/add_event",
  async (event, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/event-add", event, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const update_event = createAsyncThunk(
  "event/updateevent",
  async (event, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/event-update", event, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const event_image_update = createAsyncThunk(
  "event/event_image_update",
  async ({ oldImage, newImage, eventId }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("oldImage", oldImage);
      formData.append("newImage", newImage);
      formData.append("eventId", eventId);
      const { data } = await api.post("/event-image-update", formData, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const get_events = createAsyncThunk(
  "event/get_events",
  async ({ parPage, page, searchValue }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(
        `/events-get?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,
        { withCredentials: true }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const get_event = createAsyncThunk(
  "event/get_event",
  async (eventId, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/event-get/${eventId}`, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const delete_event = createAsyncThunk(
  "event/delete_event",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.delete(`/event-delete/${id}`, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

const eventSlice = createSlice({
  name: "event",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
    events: [],
    event: null,
    totalevent: 0,
  },
  reducers: {
    messageClear: (state) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(add_event.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
      })
      .addCase(add_event.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload?.error || action.error.message;
      })
      .addCase(add_event.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.successMessage = payload.message;
      })

      .addCase(get_events.fulfilled, (state, { payload }) => {
        state.totalevent = payload.totalevent || 0;
        state.events = payload.events || [];
      })

      .addCase(get_event.fulfilled, (state, { payload }) => {
        state.event = payload.event || null;
      })

      .addCase(update_event.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
      })
      .addCase(update_event.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload?.error || action.error.message;
      })
      .addCase(update_event.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.event = payload.event || null;
        state.successMessage = payload.message;
      })

      .addCase(event_image_update.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
      })
      .addCase(event_image_update.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload?.error || action.error.message;
      })
      .addCase(event_image_update.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.event = payload.event || null;
        state.successMessage = payload.message;
      })

      .addCase(delete_event.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
      })
      .addCase(delete_event.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload?.error || action.error.message;
      })
      .addCase(delete_event.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.successMessage = payload.message;
        // Remove the deleted event from the state list
        state.events = state.events.filter((p) => p._id !== payload.eventId);
      });
  },
});

export const { messageClear } = eventSlice.actions;
export default eventSlice.reducer;
